import * as React from "react";
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { replaceWithData } from "../../../../util";
import { PropertyContainer, } from "../../ui-props/common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";
import { ICardProps, ItemCard2 } from "./ItemCard";
import { ItemCardPropertyEditor } from "./ItemCardProperty";
import { useDataSourceContext } from "../../data-source-picker/datasource";
import './ItemCardField.scss';
interface ICardFieldProperty extends IBaseInputFieldProperty, ICardProps {
    fieldLabel: IFieldTitleProps,
}


export const Field: React.FunctionComponent<IUIFieldProps<ICardFieldProperty>> = (props) => {
    let { value, onChange } = props?.fieldProps || {};


    let styles: React.CSSProperties = {}

    let { widgetData } = useDataSourceContext() || { widgetData: null };
    let isLiveMode = props.mode !== 'preview' && props.mode !== 'thumbnail';

    let replacer = isLiveMode ?
        (x: string) => replaceWithData(x || '', widgetData)
        : (x: string) => (x || '');


    return (
        <div className={`ui-field-card ui-field ${props.mode}`} >
            <FieldTitle {...props?.fieldProps?.fieldLabel || {}} />
            <ItemCard2 topBorder={true} bottomBorder={true} {...props?.fieldProps} replacer={replacer} />
        </div>
    )
}



export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<ICardFieldProperty>> = (props) => {

    return <PropertyContainer>
        <ItemCardPropertyEditor uxpContext={props.uxpContext} onChange={props.onChange} parentUIProps={props.parentUIProps} uiProps={props.uiProps} />
        <FieldProperty uiProps={props.uiProps} onChange={props.onChange} />
    </PropertyContainer>;
}

registerUIField({
    id: 'item-card',
    description: 'Item Card',
    field: Field,
    propertyEditor: PropertyEditor,
    isInputField: true,
    defaultProps: {
        fieldLabel: {
            label: 'Text Label',
        },
        imageField: '',
        imageSize: '30',
        imageType: '',
        imageBorderType: 'square',
        imageBackgroundColor: '',
        imageIcon: '',
        imageIconColor: '',
        titleField: '',
        titleColor: '',
        titleSize: '',
        subTitleField: '',
        subTitleColor: '',
        subTitleSize: '',
        borderColor: '',
        topLabels: [],
        bottomLabels: [],
        buttons: [],
        onClick: null,

    },
});

